import './assets/css/main.css';

import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import { createPinia } from 'pinia';
import { auth } from './firebase';
import { onAuthStateChanged } from 'firebase/auth';
// import { useAuthStore } from '@/stores/auth';


import * as Sentry from "@sentry/vue";

const app = createApp(App);
const pinia = createPinia();

Sentry.init({
    app,
    dsn: "https://25a6a1703ef448cfeaa391605889d053@o44586.ingest.us.sentry.io/4509537271087104",
    // Setting this option to true will send default PII data to Sentry.
    // For example, automatic IP address collection on events
    sendDefaultPii: true
});

app.use(pinia).use(router);

onAuthStateChanged(auth, (user) => {
    const authStore = useAuthStore();

    authStore.user = user;
    authStore.loading = false;
});

app.mount('#app');
